import { FC } from 'react'
import { abbreviate, Avatar, Ellipsis, HStack } from '@revolut-internal/ui-kit'

interface UserCellProps {
  id: string
  firstName: string
  lastName: string
}

export const UserCell: FC<UserCellProps> = ({ id, firstName, lastName }) => {
  const fullName = `${firstName} ${lastName}`
  return (
    <HStack space="s-8" pl="s-12" align="center">
      <Avatar size={24} label={abbreviate(fullName)} uuid={id} />
      <Ellipsis tooltip="auto">{fullName}</Ellipsis>
    </HStack>
  )
}
